import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, FormGroup, ValidationErrors } from '@angular/forms';
import { isNullOrUndefined } from 'util';

@Directive({
  selector: '[appCheckPhone]',
  providers: [{ provide: NG_VALIDATORS, useExisting: CheckPhoneDirective, multi: true }]
})
export class CheckPhoneDirective {
  @Input() appCheckPhone = [];
  validate(formGroup: FormGroup): ValidationErrors {
    return this.checkForPhone(this.appCheckPhone)(formGroup);
  }

  private checkForPhone(controlName: string[]) {
    return (formGroup: FormGroup) => {
      const controlCheck = formGroup.controls[controlName[0]];
      const controlCheck1 = formGroup.controls[controlName[1]];
      const controlCheck2 = formGroup.controls[controlName[2]];

      // check certificate personal
      if (controlCheck != null && controlCheck.value != null && controlCheck.value !== '') {
        let initalValue = controlCheck.value;
        initalValue = initalValue.replace(/[^0-9]*/g, '');

        if (initalValue !== controlCheck.value) {
          controlCheck.setErrors({ validInput: true });
        } else {
          controlCheck.setErrors(null);
        }
      }

      // check certificate personal
      if (controlCheck1 != null && controlCheck1.value != null && controlCheck1.value !== '') {
        let initalValue = controlCheck1.value;
        initalValue = initalValue.replace(/[^0-9]*/g, '');

        if (initalValue !== controlCheck1.value) {
          controlCheck1.setErrors({ validInput: true });
        } else {
          controlCheck1.setErrors(null);
        }
      }

      // check certificate personal
      if (controlCheck2 != null && controlCheck2.value != null && controlCheck2.value !== '') {
        let initalValue = controlCheck2.value;
        initalValue = initalValue.replace(/[^0-9]*/g, '');

        if (initalValue !== controlCheck2.value) {
          controlCheck2.setErrors({ validInput: true });
        } else {
          controlCheck2.setErrors(null);
        }
      }

      if (!controlCheck || isNullOrUndefined(controlCheck.value) || controlCheck.value === '') {
        return null;
      }
    };
  }

}
